// Generated types for PortUsage
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLUsageReadAPI, SysMLUsageWriteAPI } from './sysmlusage';
import { SysMLUsageReadAPISchemaObject, SysMLUsageWriteAPISchemaObject } from './sysmlusage';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PortUsageReadAPI extends SysMLUsageReadAPI {
}

export interface PortUsageWriteAPI extends SysMLUsageWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PortUsageReadAPISchema: z.ZodType<PortUsageReadAPI> = SysMLUsageReadAPISchemaObject.extend({}).passthrough();

export const PortUsageWriteAPISchema: z.ZodType<PortUsageWriteAPI> = SysMLUsageWriteAPISchemaObject.extend({}).passthrough();
